import {connect} from "react-redux";
import VideoItem from '../../components/Video/VideoItem';
import * as VideoActions from "../../store/actions/videoActions";
import * as QuizQuestionActions from "../../store/actions/quizQuestionActions";
import * as DiscussionActions from "../../store/actions/discussionActions";
import * as AuthActions from '../../store/actions/authActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.lectureObjectives,
    ...state.videoQuestionSummery,
    ...state.quizQuestions,
    ...state.discussion,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (id, profileId, token) => {
        // console.log("onloading", id, profileId, token);
        dispatch(VideoActions.getUserLecture(id, profileId, token));

        /*
        dispatch(VideoActions.getUserChapterPart(id, token));
        dispatch(VideoActions.getUserVideoQuestions(id, profileId, token));
        dispatch(VideoActions.getUserChapterPartTest(id, userId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));


        dispatch(VideoActions.getVideoQuestionSummary());
        dispatch(VideoActions.getLectureObjectives());
        dispatch(QuizQuestionActions.getQuizQuestions());
        */
        dispatch(DiscussionActions.getDiscussion());
    },
    loadFromOldRoute: (id, token, courseUser, subjectAttempt, courseAttempt, us, profileId, userId) => {
        dispatch(VideoActions.getUserLectureFromOldRoute(id, courseUser,  subjectAttempt, courseAttempt, us, token));

        /*
        dispatch(VideoActions.getUserChapterPart(id, token));
        dispatch(VideoActions.getUserVideoQuestions(id, profileId, token));
        dispatch(VideoActions.getUserChapterPartTest(id, userId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));


        dispatch(VideoActions.getVideoQuestionSummary());
        dispatch(VideoActions.getLectureObjectives());
        dispatch(QuizQuestionActions.getQuizQuestions());
        */
        dispatch(DiscussionActions.getDiscussion());
    },
    onAdminLoad: (id, token, profileId, userId) => {
        dispatch(VideoActions.getUserChapterPart(id, token));
        dispatch(VideoActions.getUserVideoQuestions(id, profileId, token));
        dispatch(VideoActions.getUserChapterPartTest(id, userId, token));



        dispatch(VideoActions.getVideoQuestionSummary());
        dispatch(VideoActions.getLectureObjectives());
        dispatch(QuizQuestionActions.getQuizQuestions());
        dispatch(DiscussionActions.getDiscussion());
    },
    createLog: (log, token) => {
        dispatch(VideoActions.createLog(log, token));
    },
    updateLog: (log, token) => {
        dispatch(VideoActions.updateLog(log, token));
    },
    resetVideo: (videoId, profileId, cu, token) => {
        dispatch(VideoActions.deleteUserVideoQuestions(videoId, profileId, token));
        
        cu.currentVideoTime = 0;
        cu.currentPartVideoTime = 0;
        cu.attempts = cu.attempts + 1;
        dispatch(VideoActions.updateCourseUser(cu, profileId, token));
    },
    deleteChapterTest: (testId, profileId, token) => {
        dispatch(VideoActions.deleteChapterTests(testId, profileId, token));
    },
    getOrMakeQuiz: (userLectureId, token) => {
        dispatch(VideoActions.getOrMakeQuiz(userLectureId, token));
    },
    addQuizQuestion: (quizId, question, token) => {
        dispatch(VideoActions.addQuizQuestion(quizId, question, token));
    },
    updateCurrentQuestion: (quizId, mode, t, token) => {
        dispatch(VideoActions.updateCurrentQuestion(quizId, mode, t, token));
    },
    postDiscussion: (comment, user, token) => {
        dispatch(VideoActions.postDiscussion(comment, user, token));
    },
    postComment: (comment, user, token) => {
        dispatch(VideoActions.postComment(comment, user, token));
    },
    postLike: (like, token) => {
        dispatch(VideoActions.postLike(like, token))
    },
    deleteLike: (like,token) => {
        dispatch(VideoActions.deleteLike(like, token));
    },
    updateVideoQuestion: (question, token) => {
        dispatch(VideoActions.updateVideoQuestion(question, token));
    },
    fakeUpdateQuestion: (question) => {
        dispatch(VideoActions.fakeUpdateQuestion(question));  
    },
    scoreTest: (test, token) => {
        dispatch(VideoActions.scoreTest(test, token));
    },
    fakeScoreTest: (test, token) => {
        dispatch(VideoActions.fakeScoreTest(test, token));
    },
    nextChapterPart: (courseUser, token) => {
        dispatch(AuthActions.setCourseUserNextStep(courseUser, token));
    },
    createCourseNotification: (note, token) => {
        dispatch(VideoActions.createCourseNotification(note, token));
    },
    syncVideoTime: (cu, ul, token) => {
        dispatch(VideoActions.syncVideoTime(cu, ul, token));
    },
    updateUserLecture: (ul, token, success) => {
        dispatch(VideoActions.updateUserLecture(ul, token, success));
    },
    getSyllabus: (cuId) => {
        dispatch(VideoActions.getSyllabus(cuId));
    },
    sendStat: (stat, token) => {
        dispatch(VideoActions.sendStat(stat, token));
    }

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoItem);



// WEBPACK FOOTER //
// ./src/containers/Video/VideoItemContainer.js